import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { FileAttachment } from "./file-attachment.model";
import { HALResponse } from "../../../shared/model/app.model";
import { map } from "rxjs/operators";
import { GeneralParameters, Projections } from "app/shared/model/request-parameter.model";

@Injectable({
    providedIn: 'root'
})
export class FileAttachmentService {

    constructor(
        private http: HttpClient
    ) {}
    
    getFileAttachment(href: string): Observable<FileAttachment>;
    getFileAttachment(id: number): Observable<FileAttachment>;
    getFileAttachment(byValue: number | string): Observable<FileAttachment> {
        const params: GeneralParameters = {
            projection: Projections.FileAttachment.BASE
        }
        
        if (typeof byValue === 'string') {
            return this.http.get<FileAttachment>(byValue, { params: params });
        }
        else {
            params.id = byValue;
            return this.http.get<HALResponse<{ fileAttachments: FileAttachment[] }>>('/api/fileAttachments', { params: params })
                .pipe(
                    map(r => r._embedded.fileAttachments[0])
                )
        }
    }
}